// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".consignee-form[data-v-46330d3a] .ant-form-item {\n  margin-bottom: 0px;\n}\n.btnBox[data-v-46330d3a] {\n  width: 100%;\n  display: flex;\n  margin-top: 20px;\n  justify-content: center;\n}", ""]);
// Exports
module.exports = exports;
